// import axiosInstance from '../index';

import axios from 'api';

export const getDashbordConfigData = async () => {
  return axios.get(`api/elastic/dashboard_config`);
};
export const getCallFlow = async (params) => {
  return axios.post(`api/elastic/dashboard_callflow`, params);
};
export const getSamplinRate = async (params) => {
  return axios.post(`api/elastic/dashboard_sampling_rate`, params);
};
export const getAht = async (params) => {
  return axios.post(`api/elastic/dashboard_aht`, params);
};
export const getAgentScore = async (params) => {
  return axios.post(`api/elastic/dashboard_agent_quality_score`, params);
};
export const getBasicData = async (params) => {
  return axios.post(`api/elastic/dashboard_basic_component`, params);
};
export const getCqdata = async (params) => {
  return axios.post(`api/elastic/dashboard_cq_csat`, params);
};

export const getCallsdata = async (params) => {
  return axios.post(`api/elastic/dashboard_calls`, params);
};
export const getCallSentimentData = async (params) => {
  return axios.post(`api/elastic/dashboard_call_sentiment`, params);
};

export const getPerformarsData = async (params) => {
  return axios.post(`api/elastic/dashboard_performers`, params);
};

export const getTopicData = async (params) => {
  return axios.post(`api/elastic/dashboard_topic_list`, params);
};
export const getParetoData = async (params) => {
  return axios.post(`api/elastic/dashboard_defect_pareto`, params);
};
export const getKeywordsCloudData = async (params) => {
  return axios.post(`api/elastic/dashboard_keyword_cloud`, params);
};
export const getLobWiseCQData = async (params) => {
  return axios.post(`api/elastic/dashboard_lob_wise_cq`, params);
};
export const getTeamWiseCQData = async (params) => {
  return axios.post(`api/elastic/dashboard_team_wise_cq`, params);
};

export const getTrainingRequirements = async (params) => {
  return axios.post(`api/elastic/dashboard_training_requirements`, params);
};

export const getPiechartData = async (params) => {
  return axios.post(`api/elastic/dashboard_aht_pie_chart`, params);
};

export const getTenureDistribution = async (params) => {
  return axios.post(`api/elastic/dashboard_tenure_distribution`, params);
};
export const getFeatureAnalysis = async (params) => {
  return axios.post(`api/elastic/dashboard_features_analysis`, params);
};
export const getKeywordAnalaysis = async (params) => {
  return axios.post(`api/elastic/dashboard_keyword_analysis`, params);
};
export const getTopKeywords = async (params) => {
  return axios.post(`api/elastic/dashboard_top_keywords`, params);
};
export const getTopicAnalaysis = async (params) => {
  return axios.post(`api/elastic/dashboard_topic_analysis`, params);
};
export const getTopTopics = async (params) => {
  return axios.post(`api/elastic/dashboard_top_topics`, params);
};
export const getAgentqualityPerformance = async (params) => {
  return axios.post(`api/elastic/dashboard_agent_quality_performance`, params);
};
export const getCampaignSummary = async (params) => {
  return axios.post(`api/elastic/dashboard_campaign_summary`, params);
};
export const getTopIssues = async (params) => {
  return axios.post(`api/elastic/dashboard_top_issues`, params);
};
export const getRepeatedDefaulterView = async (params) => {
  return axios.post(`api/elastic/dashboard_repeated_defaulter_view`, params);
};
export const getTniView = async (params) => {
  return axios.post(`api/elastic/dashboard_tni_view`, params);
};
/*
Keywords cloud:-
    end_point :- http://demo-local.qms.servicepack.ai:8000/api/elastic/dashboard_keyword_cloud
    method:- POST
*/
